module.exports = __webpack_public_path__ + "img/nia_logo.f4731eeb.png";